/** Import Configs */
import { EventClass, EventType } from "../_game/config/Events";
import { MENU_POPUPS } from "../_game/config/Game";
/** Import store components */
import { store } from "./core.Store";
import StoreComponent from "./components/store/StoreComponent";
import { action_popError, action_pushError } from "./store/actions/actions.App";
/** Import core components */
import { __EventDispatcher, __Lang, __Utils } from "./core";

export enum ErrorSeverity {
	// stops the game, invites user to reload
	CRITICAL = 'CRITICAL',
	// critical, no input choice
	CRITICAL_NOINPUT = 'CRITICAL_NOINPUT',
	// shows a warning with OK button and you can continue
	WARNING_CONTINUE = 'WARNING_CONTINUE',
}

export class ErrorManager extends StoreComponent {
  public currentError: any;

  constructor(_props?: any) {
    super(_props);
    this.currentError = null;  
  }

  getName(): string {  
    return 'ErrorManager';
  }

  /**
   * @desc  adds an error to the state errors array
   * @param {String} _Severity - from eErrorSeverity
   * @param {String} _errorText - is displayed in the error window
   * @param {String | Number } _errorCode - more data about the error (code and error from the backend maybe)
   * @param {String} _errorDesc 
   */
  pushError(_Severity: string, _errorText: string, _errorCode: string | number, _errorDesc: string) {
    action_pushError(
      _Severity,
      _errorText,
      __Utils.isSet(_errorCode) ? _errorCode : -1,
			__Utils.isSet(_errorDesc) ? _errorDesc : '',
    )(store.dispatch);
  }
  /**
   * @desc removes the current displayed error from the queue
   *      gets called (usually) after errors that allow you to continue
   */
  popShownError() {
    action_popError()(store.dispatch);
  }

  /**
   * @desc called when store changes
   * @param prevProps 
   * @param bIsMounting 
   */
  onPropsChange(prevProps: any, bIsMounting: any): void {  
    if (this.props.arrErrors.length !== prevProps.arrErrors.length) {
			if (this.props.arrErrors.length > 0) {
				let pNewError = this.props.arrErrors[0];
				let strMessage = pNewError.text;
 
				// show error on window in debug mode
 				if (pNewError !== this.currentError) {  
					// dispatch popup request
					switch (pNewError.severity) {
						case ErrorSeverity.CRITICAL:   
							__EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
								type: MENU_POPUPS.ERROR_POPUP_CRITICAL,
								title: __Lang.getIsLoaded() ? __Lang.translate('n:play.TEXT_CRITICAL') : 'Apologies',
								content: __Lang.getIsLoaded() ? this.props.arrErrors[0].errdesc : "It looks like something did not work, but there is no need for concern.\nPlease, reload the game",
							});
							break;
						case ErrorSeverity.CRITICAL_NOINPUT:
							__EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
								type: MENU_POPUPS.ERROR_POPUP_CRITICAL_NOINPUT,
								title:
									pNewError.code === 400
										? __Lang.translate("n:play.TEXT_NOCONNECTION_TITLE")
										: __Lang.translate("n:play.TEXT_GENERIC_ERROR_TITLE"),
										content: strMessage,
							});
							break;
						default:
							__EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
								type: MENU_POPUPS.ERROR_POPUP_WARNING,
								title: __Lang.translate("n:play.TEXT_GENERIC_ERROR_TITLE"),
								content: strMessage,
							});
							break;
					}
				}
			} else { 
				this.currentError = null;
			}
    }
  }

  mapStateToProps(state: any) {
		return {
			arrErrors: state.app.arrErrors,
		};
	}
}